//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//

// noinspection JSUnresolvedReference
import React, {useEffect, useRef, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {FlexGrid} from "@grapecity/wijmo.react.grid";
import {Selector} from "@grapecity/wijmo.grid.selector";
import {Column} from "@grapecity/wijmo.grid";
import {CollectionViewNavigator, ListBox} from "@grapecity/wijmo.react.input";
import * as odata from "@grapecity/wijmo.odata";
import * as wjGridFilter from "@grapecity/wijmo.grid.filter";
import {FilterType, Operator} from "@grapecity/wijmo.grid.filter";
import * as wjcCore from "@grapecity/wijmo";
import {closest, contains, hasClass, hidePopup, showPopup} from "@grapecity/wijmo";
import * as wjcGridXlsx from "@grapecity/wijmo.grid.xlsx";
import "@grapecity/wijmo.styles/wijmo.css";
import "src/components/auditor/wijmo.css";
import Backdrop from "@material-ui/core/Backdrop";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import * as Utils from "eai-configurator-ui/components/Utils";
import {useErrorMessageDialog} from "eai-configurator-ui/components/configuration/dialog/ErrorMessageDialog";
import {Alert, AlertTitle} from "@material-ui/lab";
import Box from "@material-ui/core/Box";
import * as SessionInfo from "eai-configurator-ui/components/SessionInfo";
import {v4 as uuidv4} from 'uuid';

const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: "7px",
    marginBottom: "3px",
  },
  grid: {
    position: "relative",
    width: "100%",
    display: "grid",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#00A994",
    position: "absolute",
    backgroundColor: "rgba(255,255, 255, 0.5)",
  },
  columnPickerIcon: {
    cursor: "pointer",
    color: "#FF8754",
    margin: "3px",
  },
  columnPickerDiv: {
    display: "none",
  },
  columnPicker: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: "0 10px",
    columns: "4",
    /* IE fallback */
    padding: "12px",
    marginLeft: "12px",
    marginTop: "26px",
    boxShadow: "0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23)",
  },
  pageSizeSelect: {
    marginLeft: "15px",
  },
  eventRangeSelect: {
    marginLeft: "15px",
  },
  frozenColumnsSelect: {
    marginLeft: "5px",
    marginRight: "15px",
  },
}));

const AuditorReportPage = ({
                             path,
                             entityName,
                             epsNodes,
                             objectIds,
                             ignoredFields,
                             refreshVisible,
                             refreshDataAlways,
                             resizeAutomatically,
                             loadCustomFields,
                             loadCustomFieldsColumns,
                             reloadColumnsVisible,
                             incrementalDataRetrieval,
                             handleClickExport,
                             useAnyReportServlet,
                             dateRangeVisible,
                             appSettings,
                             requireObjectFilter,
                             showUndoButton,
                             handleUndoButtonClicked,
                             undoUndeleteActive,
                             undeletingChanges,
                             handleCancelUndoButtonClicked,
                             handleSubmitUndoButtonClicked
                           }) => {

  //
  console.log("> AuditorReportPage");

  const classes = useStyles();

  const eventRangeInitialState = () => {
    if (dateRangeVisible) {
      return Config.fromPath(path + ":eventRangeOption", true).data.value;
    } else {
      return null;
    }
  }

  const columnPicker = useRef(null);
  const uuid = useRef(uuidv4())
  const flexFilterGrid = useRef(null);

  const [flexGrid, setFlexGrid] = useState(null);
  const [flexGridView, setFlexGridView] = useState(null);
  const [flexGridColumnOrder, setFlexGridColumnOrder] = useState(null);

  // const [addedSelector, setAddedSelector] = useState(false);
  const [columnsResized, setColumnsResized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [eventRangeOptions, setEventRangeOptions] = useState(eventRangeInitialState());
  const [pageMarker, setPageMarker] = useState(false);
  const [errorMessageTitle, setErrorMessageTitle] = useState("");
  const [hideGridFilterError, setHideGridFilterError] = useState(false);
  const [dataSetInformation, setDataSetInformation] = useState()
  const [frozenColumns, setFrozenColumns] = useState(0);
  const [configurationColumnLayout, setConfigurationColumnLayout] = useState(null);
  const [needToRefreshDataAfterDataSetRetrieval, setNeedToRefreshDataAfterDataSetRetrieval] = useState(false);

  const [errorMessageContents, setErrorMessageContents] = useErrorMessageDialog();

  const rangeOptions = [
    "Full",
    "< 5m",
    "< 15m",
    "< 1h",
    "< 2h",
    "< 6h",
    "< 1d",
    "< 2d",
    "< 5d",
    "< 15d"
  ]

  const isTableCurrentlyEmpty =
    !loading && flexGridView && flexGridView.items && flexGridView.items.length === 0;

  //-------------------------------------------------------------------------
  // EFFECTS
  //-------------------------------------------------------------------------

  /*
  This effect is fired when the page starts loading. Should be called just once.
   */
  useEffect(() => {
    console.log(">> useEffect [] - new odata.ODataCollectionView")

    let url = (useAnyReportServlet ?
      Utils.getBaseUrl() + "auditor/data/Any.svc/" :
      Utils.getBaseUrl() + "auditor/data/" + entityName + ".svc/");
    console.log("Report URL: " + url)
    let oDataView = new odata.ODataCollectionView(
      url,
      entityName,
      {
        pageSize: pageSize,
        pageOnServer: true,
        pageChanged: onPageChanged
      }
    );

    refreshRequestHeaders(oDataView);
    oDataView.refresh();
    setLoading(true);
    setFlexGridView(oDataView);
  }, []);

  /*
  This effect is fired when the data needs to be loaded from the server.
   */
  useEffect(() => {
    console.log(">> useEffect [flexGridView, epsNodes, objectIds, ignoredFields, eventRangeOptions, loadCustomFields, loadCustomFieldsColumns, incrementalDataRetrieval, undoUndeleteActive] - view.load, loading: " + loading);

    if (!loading) {
      if (flexGridView) {
        refreshRequestHeaders(flexGridView);
        flexGridView.load();
      }
    }
  }, [flexGridView, epsNodes, objectIds, ignoredFields, eventRangeOptions, loadCustomFields, loadCustomFieldsColumns, incrementalDataRetrieval, undoUndeleteActive]);

  /*
   * This effect is used to add and remove handlers to the flex grid for things like data loading/ error handling, etc...
   */
  useEffect(() => {
    console.log(">> useEffect [view, loading, columnCount] - view handlers and add handler")

    if (flexGridView) {
      flexGridView.loaded.addHandler(handleLoadedRows);
      flexGridView.loading.addHandler(handleLoadingRows);
      flexGridView.error.addHandler(handleError);
      return () => {
        flexGridView.loaded.removeHandler(handleLoadedRows);
        flexGridView.loading.removeHandler(handleLoadingRows);
        flexGridView.error.removeHandler(handleError);
      };
    }
  }, [flexGridView, loading]);

  /*
  Initializes the column picker.
   */
  useEffect(() => {
    console.log(">> useEffect [flex, columnPicker.current] - picker source")

    if (flexGrid && columnPicker.current) {
      const picker = columnPicker.current;
      picker.itemsSource = flexGrid.columns;
      picker.checkedMemberPath = "visible";
      picker.displayMemberPath = "header";
      picker.isContentHtml = true;
      picker.lostFocus.addHandler(() => {
        hidePopup(picker.hostElement);
      });
    }
  }, [flexGrid, columnPicker.current]);

  /*
  Shows/ hide the grid depending if some object is selected or not.
   */
  useEffect(() => {
    console.log(">> useEffect [objectIds] - hiding or showing grid")

    if (requireObjectFilter) {
      if (Array.isArray(objectIds) && objectIds.length > 0) {
        setHideGridFilterError(false);
      } else {
        console.log("Hiding grid");
        setHideGridFilterError(true);
      }
    } else {
      setHideGridFilterError(false);
    }
  }, [objectIds])

  /*
  Update the columns as needed.
   */
  useEffect(() => {
    console.log(">> useEffect [columnLayout, dataSetInformation, pageMarker] - updateColumns()")

    updateColumns(dataSetInformation && dataSetInformation.firstEmptyResponse);
    configureFiltersFromDataset();
    if (dataSetInformation && dataSetInformation.firstEmptyResponse && needToRefreshDataAfterDataSetRetrieval && flexGridView) {
      setNeedToRefreshDataAfterDataSetRetrieval(false);
      flexGridView.load();
      flexGridView.refresh();
    }
  }, [configurationColumnLayout, dataSetInformation, pageMarker]);

  //-------------------------------------------------------------------------
  // EVENT HANDLERS
  //-------------------------------------------------------------------------

  const onPageChanged = () => {
    console.log(">> onPageChanged")

    setPageMarker(pageMarker => !pageMarker)
  }

  const onClearFiltersButtonClick = () => {
    console.log(">> handleClearFilters")

    flexFilterGrid.current.clear();

    // Clear sort as well
    flexGridView.sortDescriptions.length = 0;

    setErrorMessageTitle(null);
    setErrorMessageContents(null);

    // For some reason Wijmo resets the configured columns when clearing so make sure to configure them again
    configurePredefinedCustomColumnFilters();

    // Argh
    flexGridView.refresh()
  };

  const onReloadColumnsButtonClick = () => {
    updateColumns();
  }

  const handleError = (param, errorEventArgs) => {
    console.log(">> handleError (param:, errorEventArgs) - table follows")
    console.table(param)
    console.table(errorEventArgs)

    if (errorEventArgs.request.status === 401) {
      SessionInfo.clear();
      return;
    }

    let errorMessageTitle = "Server Error";
    let errorMessageDescription;
    let errorJson = errorEventArgs.request.responseText;
    if (errorJson) {
      try {
        errorJson = JSON.parse(errorJson);
      } catch (e) {
        // Ignore json parsing issues
        console.log("Error parsing json response: ", e)
      }
      if (errorJson && errorJson.error) {
        errorMessageDescription = errorJson.error.message;
      }
    }
    if (!errorMessageDescription) {
      errorMessageDescription = "Unknown internal server error";
    }
    setErrorMessageTitle(errorMessageTitle);
    setErrorMessageContents(errorMessageDescription);
  };

  const handleInitializeColumnPicker = (p) => {
    console.log(">> handleInitializeColumnPicker")

    columnPicker.current = p;
  };

  const handleChangeFrozenColumns = (event) => {
    console.log(">> handleChangeFrozenColumns - event):")

    const frozenColumnsFromEvent = event.target.value;
    setFrozenColumns(frozenColumnsFromEvent);
    Config.setDataValue(getTableConfigPath() + ":frozenColumns", frozenColumnsFromEvent);
    //issueSaveRequest();

    if (flexGrid) {
      flexGrid.frozenColumns = parseInt(frozenColumnsFromEvent, 10);
    }
  };

  const handleChangeEventRange = (event) => {
    setEventRangeOptions(event.target.value)
    Config.setDataValue(path + ":eventRangeOption", event.target.value);
    //issueSaveRequest();
  };

  const handleLoadedRows = (collectionView, eventArgs) => {
    console.log(`>> handleLoadedRows (firstLoad: ${firstLoad}, flex: ${flexGrid}, loading: ${loading}`)

    if (firstLoad && flexGrid && !loading) {
      setFirstLoad(false);
      const filtersChanged = loadTableState();

      // If the filters have NOT changed, and this is the first load, the data needs to be refreshed after the data set information is retrieved
      // This of course only applies if the response is the first one
      if (!filtersChanged) {
        setNeedToRefreshDataAfterDataSetRetrieval(true);
      }
    }

    if (loading) {
      setLoading(false);
    } else {
      // Always reset the headers on the response to make sure the refresh flag is set to false in the headers
      refreshRequestHeaders(flexGridView, false)
      processDataSetInformation();
    }
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(">> handleChangeRowsPerPage - event:")

    const pageSize = event.target.value;
    setPageSize(pageSize);
    if (flexGridView) {
      refreshRequestHeaders(flexGridView, false, pageSize)
    }

    flexGridView.pageSize = pageSize;
    Config.setDataValue(getTableConfigPath() + ":pageSize", pageSize);
  };

  const handleLoadingRows = (param) => {
    console.log(">> handleLoadingRows")

    setLoading(true);
    setErrorMessageContents(null);
  };

  const onRefreshButtonClick = () => {
    handleRefresh();
  };

  const handleRefresh = () => {
    console.log(">> handleRefresh")

    refreshRequestHeaders(flexGridView, true);

    flexGridView.load();

    setErrorMessageTitle(null);
    setErrorMessageContents(null);

    flexGridView.refresh()
  }

  const initializedGridHandler = (ctl) => {
    console.log(">> initializedGrid")

    //
    // Sets the filter expressions to be the only ones allowed on string columns
    // if (appSettings && appSettings.primaveraDataServicesSource) {
    //   wjcCore.culture.FlexGridFilter.stringOperators = [{name: '(not set)', op: null},
    //     {name: 'Equals', op: Operator.EQ},
    //     {name: 'Does not equal', op: Operator.NE}]
    // }

    const filter = new wjGridFilter.FlexGridFilter(ctl);
    filter.defaultFilterType = "Condition";
    flexFilterGrid.current = filter;
    filter.onFilterChanged = onFilterChanged
    setFlexGrid(ctl);

    //ct

    ctl.formatItem.addHandler((s, e) => {
      if (e.panel === s.topLeftCells) {
        e.cell.innerHTML =
          '<span class="wj-glyph-filter glyphicon glyphicon-cog"></span>';
      }
    });


    // show the column picker when the user clicks the top-left cell
    let ref = ctl.hostElement.querySelector(".wj-topleft");
    ref.addEventListener("mousedown", (e) => {
      if (hasClass(e.target, "wj-glyph-filter")) {
        let host = columnPicker.current.hostElement;
        if (!host.offsetHeight) {
          showPopup(host, ref, false, true, false);
          columnPicker.current.focus();
        } else {
          hidePopup(host, true, true);
          ctl.focus();
        }
        columnPicker.current.focus();
        e.preventDefault();
      }
    });

    // ctl.itemsSource.onPageChange += () => {
    //   console.log("Page changed");
    // }

    // work around Safari/IOS bug (TFS 321525, 361500, 402670)
    // https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile
    window.addEventListener("touchstart", (e) => {
      let host = columnPicker.current.hostElement;
      if (!contains(host, e.target) && !closest(e.target, ".wj-flexgrid")) {
        hidePopup(host, true, true);
      }
    });
  };

  const exportToExcelHandler = () => {
    console.log(">> exportToExcel")

    wjcGridXlsx.FlexGridXlsxConverter.saveAsync(
      flexGrid,
      {
        includeColumnHeaders: true,
        includeCellStyles: false,
        formatItem: null,
      },
      entityName + "Grid.xlsx"
    );
    if (handleClickExport) {
      handleClickExport();
    }
  };

  const columnDraggedHandler = (flexGrid, eventArgs) => {
    console.log(">> columnDraggedHandler");
    if (flexGrid) {
      setFlexGridColumnOrder(flexGrid.columnLayout);
      saveColumnLayout(flexGrid);
    }
  }

  const columnResizedHandler = (flexGrid, eventArgs) => {
    console.log(">> columnResizedHandler");
    if (flexGrid) {
      saveColumnLayout(flexGrid);
    }
  }

  const columnSortedColumn = (flexGrid, eventArgs) => {
    console.log(">> columnSortedColumn");
    if (flexGrid) {
      saveColumnLayout(flexGrid);
    }
  }

  const onFilterChanged = (event) => {
    let filters = flexFilterGrid.current
    if (filters) {
      saveColumnFilters(filters);
    }
  }

  //-------------------------------------------------------------------------
  // FUNCTIONS
  //-------------------------------------------------------------------------

  const saveColumnLayout = (flexGrid) => {
    if (flexGrid && flexGrid.columnLayout) {
      Config.setDataValue(
        getTableConfigPath() + ":columnLayout",
        flexGrid.columnLayout
      );
    }
  }

  const saveColumnFilters = (filters) => {
    if (filters) {
      Config.setDataValue(
        getTableConfigPath() + ":filterDefinition",
        filters.filterDefinition
      );
    }
  }

  const refreshRequestHeaders = (oDataView, refresh = false, setPageSize = pageSize) => {
    console.log(`>> refreshRequestHeaders(refresh=${refresh}, firstLoad=${firstLoad}, refreshDataAlways=${refreshDataAlways}, loadCustomFields=${loadCustomFields}, loadCustomFieldsColumns=${loadCustomFieldsColumns}`)

    const requestHeaders = {};
    if (firstLoad) {
      requestHeaders["FirstRequest"] = "true";
    }
    if (refresh === true || refreshDataAlways === true) {
      requestHeaders["ForceRefresh"] = "true";
    }
    if (loadCustomFields === true) {
      requestHeaders["LoadCustomFields"] = "true";
    }
    if (incrementalDataRetrieval === true) {
      if (undoUndeleteActive) {
        console.log(">>> refreshRequestHeaders, undo is active, set incremental data retrieval to false")
        requestHeaders["IncrementalDataRetrieval"] = "false";
      } else {
        requestHeaders["IncrementalDataRetrieval"] = "true";
      }
    }
    if (loadCustomFieldsColumns === true) {
      requestHeaders["LoadCustomFieldsColumns"] = "true";
    }
    if (eventRangeOptions) {
      requestHeaders["EventRangeOptions"] = eventRangeOptions.toString();
    }
    if (setPageSize) {
      requestHeaders["PageSize"] = setPageSize.toString();
    }
    if (undoUndeleteActive) {
      requestHeaders["UndoUndeleteActive"] = "true";
    }
    if (undeletingChanges) {
      requestHeaders["UndeletingChanges"] = "true";
    }
    if (epsNodes && epsNodes.toString()) {
      if (epsNodes.includes("projects")) {
        requestHeaders["EpsFilter"] = "projects";
      } else {
        requestHeaders["EpsFilter"] = epsNodes.toString();
      }
    }
    if (objectIds && objectIds.toString()) {
      if (objectIds.includes("objects")) {
        requestHeaders["ObjectFilter"] = "objects";
      } else {
        requestHeaders["ObjectFilter"] = objectIds.toString();
      }
    }
    if (ignoredFields) {
      requestHeaders["IgnoredFields"] = ignoredFields;
    }
    if (uuid.current) {
      requestHeaders["RequestUUID"] = uuid.current
    }
    const filters = Config.getDataValue(
      getTableConfigPath() + ":filterDefinition",
    );
    if (filters) {
      const filterObject = JSON.parse(filters)
      if (filterObject.filters && Array.isArray(filterObject.filters)) {
        requestHeaders["FilterColumns"] = filterObject.filters.map((obj) => obj.binding).join(",");
      }
    }


    console.log("Request headers - table follows:");
    console.table(requestHeaders);

    oDataView.requestHeaders = requestHeaders;
  };

  const resizeColumns = () => {
    if (flexGrid && dataSetInformation && dataSetInformation.firstEmptyResponse) {
      flexGrid.autoSizeColumns();
      return;
    }

    if (flexGrid && resizeAutomatically) {
      flexGrid.autoSizeColumns();
      return;
    }

    if (flexGrid && columnsResized) {
      return;
    }

    if (flexGrid && dataSetInformation && dataSetInformation.validDataResponse) {
      let numberOfRows = dataSetInformation.totalRowCount
      if (numberOfRows && numberOfRows > 0) {
        setColumnsResized(true);
        flexGrid.autoSizeColumns();
      }
    }
  }

  const processDataSetInformation = () => {
    Utils.fetchData("auditor/data/datasetInformation?uuid=" + uuid.current, null, false, true)
      .then((response) => {
        setDataSetInformation(response);
      }).catch((response) => {
      Utils.getErrorMessage(response, "Error getting dataset information").then(setErrorMessageContents);
      setErrorMessageTitle("Error")
    });
  };

  const updateColumns = (firstEmptyResponse) => {
    console.log(">> updateColumns");
    const dataSetColumnOrder = updateColumnsFromDataset();

    if (firstEmptyResponse) {
      updateColumnOrderFromMap(dataSetColumnOrder)
    } else if (flexGridColumnOrder) {
      updateColumnOrderFromSavedGridLayout(flexGridColumnOrder);
    } else if (configurationColumnLayout) {
      updateColumnOrderFromConfigurationColumnLayout();
    } else if (dataSetColumnOrder) {
      updateColumnOrderFromMap(dataSetColumnOrder)
    }

    resizeColumns();

    if (undoUndeleteActive) {
      if (flexGrid && flexGrid.columns) {
        flexGrid.columns.forEach((column) => {
          if (column.binding === "Undo") {
            if (column.cssClass !== "column-set") {
              //setAddedSelector(true);

              column.width = 90;
              column.isReadOnly = false;
              column.align = 'center';
              column.cssClass = "column-set"

              new Selector(column, {});
            }
          }
        });
      }
    } else {
      if (flexGrid && flexGrid.columns) {
        let removeColumns = flexGrid.columns.filter((column) => column.binding === "Undo");
        for (const removeColumn of removeColumns) {
          //setAddedSelector(false);
          flexGrid.columns.remove(removeColumn);
        }
      }
    }
    // add a SelectorColumn to the first row data column
  }

  const updateColumnsFromDataset = () => {
    console.log(">> updateColumnsFromDataset");

    if (!(flexGrid && flexGrid.columns && dataSetInformation)) {
      return
    }

    let targetColumns = flexGrid.columns
    let columnsFromLayout = new Set();
    let hasColumns = false
    if (configurationColumnLayout) {
      const columnLayoutObj = JSON.parse(configurationColumnLayout);
      const sourceColumns = columnLayoutObj.columns
      if (sourceColumns) {
        hasColumns = true;
        let pos = 0;
        while (pos < sourceColumns.length) {
          let el = sourceColumns[pos];
          columnsFromLayout.add(el.binding);
          pos++;
        }
      }
    }

    if (!(targetColumns)) {
      return
    }

    //
    // Adds any missing event columns and remove any extra event columns - make navigation clean 
    //
    let sourceColumns = dataSetInformation.dataSetColumnsFromMeta
    let sourceColumnBindingArray = sourceColumns.map((column) => column.formattedName)
    let sourceColumnSet = new Set(sourceColumnBindingArray);
    let targetColumnBindingArray = targetColumns.map((column) => column.binding)
    let targetColumnSet = new Set(targetColumnBindingArray);

    //
    // Adds any missing regular columns 
    for (let sourceColumn of sourceColumns) {
      if (targetColumnSet.has(sourceColumn.formattedName)) {
        continue
      }

      if (sourceColumn && sourceColumn.formattedName && !sourceColumn.formattedName.startsWith(":")) {
        let newColumn = new Column(
          {
            name: sourceColumn.formattedName,
            header: sourceColumn.formattedName,
            binding: sourceColumn.formattedName
          });
        flexGrid.columns.push(newColumn);
      }
    }

    //
    // Adds any missing event columns 
    for (let sourceColumn of sourceColumns) {
      if (targetColumnSet.has(sourceColumn.formattedName)) {
        continue
      }

      if (sourceColumn && sourceColumn.formattedName && sourceColumn.formattedName.startsWith(":")) {
        let newColumn = new Column(
          {
            name: sourceColumn.formattedName,
            header: sourceColumn.formattedName,
            binding: sourceColumn.formattedName
          });
        flexGrid.columns.push(newColumn);
      }
    }

    //
    // Removes any extra event columns that are not in the layout
    let removeColumns = new Set()
    let filters = flexFilterGrid.current
    console.table(filters)
    for (const targetColumn of targetColumns) {
      if (targetColumn.binding && targetColumn.binding === "LoadingData..." && dataSetInformation && dataSetInformation.validDataResponse) {
        removeColumns.add(targetColumn)
        continue
      }

      if (targetColumn.binding && targetColumn.binding.startsWith(":")) {
        let targetColumnFilter = flexFilterGrid.current.getColumnFilter(targetColumn.binding);
        if (targetColumnFilter && targetColumnFilter.isActive) {
          // Won't remove an active filter
          continue
        }

        if (!sourceColumnSet.has(targetColumn.binding)) {
          if (hasColumns && columnsFromLayout.has(targetColumn.binding)) {
            console.log(`Column ${targetColumn.binding} is in layout, won't remove it`)
          } else {
            console.log("Will remove column [" + targetColumn.binding + "]")
            removeColumns.add(targetColumn)
          }
        }
      }
    }

    for (const removeColumn of removeColumns) {
      flexGrid.columns.remove(removeColumn);
    }

    const sourceColumnPositionMap = new Map();
    for (const sourceColumn of sourceColumns) {
      sourceColumnPositionMap.set(sourceColumn.formattedName, sourceColumn.index);
    }
    //updateColumnOrderFromMap(sourceColumnPositionMap);

    return sourceColumnPositionMap;
  }

  const updateColumnOrderFromConfigurationColumnLayout = () => {
    console.log(">> updateColumnOrderFromConfigurationColumnLayout");

    if (configurationColumnLayout && flexGrid && flexGrid.columns) {
      updateColumnOrderFromSavedGridLayout(configurationColumnLayout);
    }
  }

  const updateColumnOrderFromSavedGridLayout = (savedColumnLayout) => {
    console.log(">> updateColumnOrderFromSavedGridLayout");

    if (savedColumnLayout && flexGrid && flexGrid.columns) {
      const columnLayoutObj = JSON.parse(savedColumnLayout);
      const sourceColumns = columnLayoutObj.columns

      if (sourceColumns) {
        const sourceColumnPositionMap = new Map();
        const sourceColumnWidthMap = new Map();

        let pos = 0;
        while (pos < sourceColumns.length) {
          let el = sourceColumns[pos];
          sourceColumnPositionMap.set(el.binding, pos);
          sourceColumnWidthMap.set(el.binding, el.width);
          pos++;
        }

        updateColumnOrderFromMap(sourceColumnPositionMap);

        let targetColumns = flexGrid.columns
        targetColumns.forEach((column) => {
          let width = sourceColumnWidthMap.get(column.binding)
          if (width) {
            column.width = width;
          }
        });
      }
    }
  }

  const updateColumnOrderFromMap = (sourceColumnPositionMap) => {
    console.log(">> updateColumnOrderFromMap");

    if (flexGrid && flexGrid.columns) {
      let targetColumns = flexGrid.columns
      targetColumns.sort((el1, el2) => {
        if (el1.binding === "Undo") {
          return -1;
        } else if (el2.binding === "Undo") {
          return +1;
        }

        const pos1 = sourceColumnPositionMap.get(el1.binding);
        const pos2 = sourceColumnPositionMap.get(el2.binding);
        if (!isNaN(pos1) && !isNaN(pos2)) {
          if (pos1 < pos2) {
            return -1;
          } else if (pos1 > pos2) {
            return +1;
          } else {
            return 0;
          }
        } else if (!isNaN(pos1)) {
          return -1;
        } else if (!isNaN(pos2)) {
          return +1;
        } else {
          return 0;
        }
      });
    }
  }

// const queueSaveTableStateTimer = () => {
//   console.log(">> queueSaveTableStateTimer");
//   setTimeout(saveTableState);
// };

  const getTableConfigPath = () => {
    return `${path}:${entityName}`;
  };

  /**
   * Customize common enum columns by defining special filter editors.
   */
  const configurePredefinedCustomColumnFilters = () => {
    console.log(">> configureCustomColumnFilters")

    //
    // Sets the filter expressions to be the only ones allowed on string columns
    if (appSettings && appSettings.primaveraDataServicesSource) {
      flexFilterGrid.current.stringOperators = [{name: '(not set)', op: null},
        {name: 'Equals', op: Operator.EQ},
        {name: 'Does not equal', op: Operator.NE}]
    }
  };

  /**
   * Customize common enum columns by defining special filter editors.
   */
  const configureFiltersFromDataset = () => {
    console.log(">> configureFiltersFromDataset")

    const filter = flexFilterGrid.current
    if (filter && dataSetInformation && dataSetInformation.customFilters) {
      for (let [key, value] of Object.entries(dataSetInformation.customFilters)) {
        console.log(key)
        let column = flexFilterGrid.current.getColumnFilter(
          key
        );
        if (column) {
          column.valueFilter.uniqueValues = value
          column.filterType = FilterType.Value; // set the filter type
        }
      }
    }
  };

  const configureFilters = (forceSet) => {
    console.log(">> configureFilters")

    let filtersChanged = false

    try {
      const filterDefinition = Config.fromPath(
        getTableConfigPath() + ":filterDefinition",
        true
      ).data.value;

      console.log(`>>> configureFilters - filter definition (wanted) - ${filterDefinition}`);
      console.log(`>>> configureFilters - filter definition (current.filterDefinition) - ${flexFilterGrid.current.filterDefinition}`);

      if (filterDefinition && (
        flexFilterGrid.current.filterDefinition !== filterDefinition || forceSet)
      ) {
        console.log(`>>> configureFilters - setting grid definition to ${filterDefinition}`);
        flexFilterGrid.current.filterDefinition = filterDefinition;
        filtersChanged = true;
      }

      configurePredefinedCustomColumnFilters();
    } catch (e) {
      console.error("Error in configureFilters: " + e);
    }

    return filtersChanged
  }

  const loadTableState = () => {
    console.log(">> loadTableState")

    const columnLayout = Config.fromPath(
      getTableConfigPath() + ":columnLayout",
      true
    ).data.value;

    let sortDescriptions = Config.fromPath(
      getTableConfigPath() + ":sortDescriptions",
      true
    ).data.value;

    let pageSizeFromConfig = Config.fromPath(
      getTableConfigPath() + ":pageSize", true
    ).data.value;

    let frozenColumnsFromConfig = Config.fromPath(
      getTableConfigPath() + ":frozenColumns", true
    ).data.value;

    if (columnLayout) {
      setColumnsResized(true);
      setConfigurationColumnLayout(columnLayout);
    } else {
      resizeColumns();
    }

    let filtersChanged = configureFilters();
    configureFiltersFromDataset();

    const view = flexGrid.collectionView;
    if (sortDescriptions) {
      sortDescriptions = JSON.parse(sortDescriptions);
      // restore sort state
      view.deferUpdate(function () {
        view.sortDescriptions.clear();
        for (var i = 0; i < sortDescriptions.length; i++) {
          var sortDesc = sortDescriptions[i];
          view.sortDescriptions.push(
            new wjcCore.SortDescription(sortDesc.property, sortDesc.ascending)
          );
        }
      });
    }

    if (!isNaN(pageSizeFromConfig) && parseInt(pageSizeFromConfig)) {
      setPageSize(pageSizeFromConfig);
      view.pageSize = parseInt(pageSizeFromConfig);
    }
    if (!isNaN(frozenColumnsFromConfig) && parseInt(frozenColumnsFromConfig)) {
      setFrozenColumns(frozenColumnsFromConfig);
      if (flexGrid) {
        flexGrid.frozenColumns = parseInt(frozenColumnsFromConfig);
      }
    }

    return filtersChanged;
  };

  const handleSubmitUndoButtonClickedInternal = () => {
    if (handleSubmitUndoButtonClicked && flexGrid) {
      const selectedItems = flexGrid.selectedItems.map((item) => item.AuditRecordKey);
      handleSubmitUndoButtonClicked(selectedItems);
    }
  }
  //
  // const onFlexgridChange = (event) => {
  //   console.log("event");
  // }

  return (
    <>
      {errorMessageContents.open && (
        <Alert severity="warning" variant="outlined">
          <AlertTitle style={{marginBottom: 10}}>
            <Box display="flex" flexDirection="row">
              {errorMessageTitle}
              <div className={classes.grow}/>
            </Box>
            <Typography variant="body2" color="textPrimary">
              <p/>
              {errorMessageContents.description}
            </Typography>
          </AlertTitle>
        </Alert>
      )}
      <Box style={{marginTop: 4}}>
        <CollectionViewNavigator
          headerFormat="Page {currentPage:n0} of {pageCount:n0}"
          byPage={true}
          cv={flexGridView}
        />
        <Button
          variant="outlined"
          className={classes.button}
          onClick={onClearFiltersButtonClick}
        >
          Clear Filters
        </Button>
        {refreshVisible && <Button
          variant="outlined"
          className={classes.button}
          onClick={onRefreshButtonClick}
        >
          Refresh
        </Button>
        }
        {reloadColumnsVisible &&
          <Button
            variant="outlined"
            className={classes.button}
            onClick={onReloadColumnsButtonClick}
          >
            Reload Columns
          </Button>
        }
        <Button
          variant="outlined"
          className={classes.button}
          onClick={exportToExcelHandler}
        >
          Export
        </Button>
        {showUndoButton && !undeletingChanges && (<Button
          variant="outlined"
          className={classes.button}
          onClick={handleUndoButtonClicked}
        >
          Undo
        </Button>)
        }
        {showUndoButton && undeletingChanges && (<>
          <Button
            variant="outlined"
            className={classes.button}
            onClick={handleSubmitUndoButtonClickedInternal}
          >
            Submit Undo
          </Button>
          <Button
            variant="outlined"
            className={classes.button}
            onClick={handleCancelUndoButtonClicked}
          >
            Cancel Undo
          </Button>
        </>)
        }
        <FormControl className={classes.pageSizeSelect}>
          <Select value={pageSize} onChange={handleChangeRowsPerPage}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
            <MenuItem value={500}>500</MenuItem>
            <MenuItem value={1000}>1000</MenuItem>
            <MenuItem value={5000}>5000</MenuItem>
            <MenuItem value={10000}>10000</MenuItem>
            <MenuItem value={20000}>20000</MenuItem>
          </Select>
          <FormHelperText>Rows per page</FormHelperText>
        </FormControl>
        {dateRangeVisible && (
          <FormControl className={classes.eventRangeSelect}>
            <Select
              value={eventRangeOptions}
              onChange={handleChangeEventRange}
            >
              {rangeOptions.map((option) => (
                <MenuItem value={option}>{option}</MenuItem>
              ))}
            </Select>
            <FormHelperText>Event range</FormHelperText>
          </FormControl>)}
        <FormControl className={classes.frozenColumnsSelect}>
          <Select value={frozenColumns} onChange={handleChangeFrozenColumns}>
            <MenuItem value="0">0</MenuItem>
            <MenuItem value="1">1</MenuItem>
            <MenuItem value="2">2</MenuItem>
            <MenuItem value="3">3</MenuItem>
            <MenuItem value="4">4</MenuItem>
            <MenuItem value="5">5</MenuItem>
          </Select>
          <FormHelperText>Frozen columns</FormHelperText>
        </FormControl>
        {dataSetInformation && dataSetInformation.rowLimitReached && (
          <Tooltip
            title="Result set may be truncated. This occurs when there are too many records being returned from the database. You may want to refine your filters.">
            <Typography component="span" variant="body2" style={{color: "red"}}>Result set may be truncated *.</Typography>
          </Tooltip>)
        }
        {dataSetInformation && dataSetInformation.rowLimitReached === false && incrementalDataRetrieval && (
          <Tooltip
            title="Results are incremental. The number of pages shown may not reflect the total amount of data on the table.">
            <Typography component="span" variant="body2" style={{color: "blue"}}>Result set is incremental *.</Typography>
          </Tooltip>)}
      </Box>
      <div className={classes.grid}>
        {!hideGridFilterError && (
          <FlexGrid
            stickyHeaders={true}
            initialized={initializedGridHandler}
            alternatingRowStep={0}
            itemsSource={flexGridView}
            draggedColumn={columnDraggedHandler}
            resizedColumn={columnResizedHandler}
            sortedColumn={columnSortedColumn}
          >
            <Backdrop className={classes.backdrop} open={loading}>
              <CircularProgress color="inherit" size={25}/>
            </Backdrop>
            <Backdrop
              className={classes.backdrop}
              open={isTableCurrentlyEmpty && flexGrid && flexGrid.columns.length === 0}
            >
              <Typography variant="body2" color="textPrimary">
                No records found
              </Typography>
            </Backdrop>
          </FlexGrid>
        )}
        {hideGridFilterError && (
          "Please select one or more objects in the 'Filter by' area to show usage results"
        )}
        <div className={classes.columnPickerDiv}>
          <ListBox
            className={classes.columnPicker}
            initialized={handleInitializeColumnPicker}
          />
        </div>
      </div>
    </>
  );
}
export default AuditorReportPage;
